// extracted by mini-css-extract-plugin
export default {"page":"VenuePlanner3D_page__pay2P","filters":"VenuePlanner3D_filters__NRWht","hotelSection":"VenuePlanner3D_hotelSection__KFXIw","body":"VenuePlanner3D_body__9WgXt"};